// extracted by mini-css-extract-plugin
export default {"wrapper":"ClubTeams_wrapper__ddfX1","contentWrapper":"ClubTeams_contentWrapper__3Dvy_"};